import { CdkDrag, CdkDragDrop, CdkDragMove, CdkDropList, CdkDropListGroup } from '@angular/cdk/drag-drop';
import { ViewportRuler } from '@angular/cdk/overlay';
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, HostBinding, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { IsDuplicatePKError } from 'dbweb-core';
import { ConfirmDialogComponent } from '../../../components/confirm-dialog/confirm-dialog.component';
import { Category } from '../../../services/eleview/types/category';
import { Label } from '../../../services/eleview/types/label';
import { DialogData, EditCategoryDialogComponent } from '../edit-category-dialog/edit-category-dialog.component';
import { EditLabelComponent } from '../edit-label/edit-label.component';
import { LabelManagerService } from '../service/label-manager.service';
interface Item {
	CategoryID: string;
	ID: string;
	Name: string;
}
@Component({
	selector: 'common-label-category',
	templateUrl: './label-category.component.html',
	styleUrls: ['./label-category.component.scss']
})
export class CategoryComponent implements OnInit, AfterViewInit {
	@Input() category: Category;
	@HostBinding('class.label-category') hostClass = true;
	@ViewChild(CdkDropListGroup, { static: true }) listGroup: CdkDropListGroup<CdkDropList>;
	@ViewChild(CdkDropList, { static: true }) placeholder: CdkDropList;
	public target: CdkDropList;
	public targetIndex: number;
	public source: CdkDropList = null;
	public sourceIndex: number;
	public dragIndex: number;
	public activeContainer: CdkDropList;
	constructor(
		public svr: LabelManagerService,
		public dialog: MatDialog,
		private snackBar: MatSnackBar,
		private viewportRuler: ViewportRuler,
		private cd: ChangeDetectorRef
	) {}
	ngOnInit() {}

	ngAfterViewInit() {
		const phElement = this.placeholder.element.nativeElement;

		phElement.style.display = 'none';
		phElement.parentElement.removeChild(phElement);
	}
	add(): void {
		this.svr.editLabel.add(this.category.ID);
		this.dialog.open(EditLabelComponent, {
			width: '800px',
			height: '100%',
			minWidth: '800px',
			data: this.svr,
			position: {
				top: '0px',
				right: '0px'
			}
		});
	}
	addCategoryClick(): void {
		const dialogRef = this.dialog.open(EditCategoryDialogComponent, {
			width: '360px',
			height: '224px',
			data: {
				name: 'æ°çç±»å«',
				title: 'å¢å æ°çç±»å«'
			}
		});

		dialogRef.afterClosed().subscribe((result: DialogData) => {
			if (result) {
				this.svr
					.addCategory({ name: result.name, beforeAtID: this.category.ID })
					.subscribe(() => {}, this.errProcess());
			}
		});
	}
	private errProcess(): (error: any) => void {
		return err => {
			if (err instanceof HttpErrorResponse) {
				const derr = IsDuplicatePKError(err.error);
				if (derr.Yes) {
					this.snackBar.open('åç§°éå¤', 'å³é­', { duration: 5000 });
				} else {
					this.snackBar.open(err.error, 'å³é­', { duration: 5000 });
				}
			} else {
				this.snackBar.open(err, 'å³é­', { duration: 5000 });
			}
		};
	}

	editCategoryClick(): void {
		const dialogRef = this.dialog.open(EditCategoryDialogComponent, {
			width: '360px',
			height: '224px',
			data: {
				name: this.category.Name,
				title: 'ä¿®æ¹ç±»å«'
			}
		});

		dialogRef.afterClosed().subscribe((result: DialogData) => {
			if (result) {
				this.svr
					.editCategory({ name: result.name, id: this.category.ID })
					.subscribe(() => {}, this.errProcess());
			}
		});
	}
	up() {
		this.svr.setCategoryPosition(this.category, this.category.Position - 1);
	}
	down() {
		this.svr.setCategoryPosition(this.category, this.category.Position + 1);
	}
	delete() {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '360px',
			height: '224px',
			data: `ç¡®å®è¦å é¤ç±»å«[${this.category.Name}]åå¶ææçæ ç­¾åï¼`
		});

		dialogRef.afterClosed().subscribe((result: boolean) => {
			if (result) {
				this.svr.removeCategory(this.category.ID).subscribe(() => {}, this.errProcess());
			}
		});
	}
	dragMoved(e: CdkDragMove) {
		const point = this.getPointerPositionOnPage(e.event);

		this.listGroup._items.forEach(dropList => {
			if (__isInsideDropListClientRect(dropList, point.x, point.y)) {
				this.activeContainer = dropList;
				return;
			}
		});
	}

	dropListDropped(event: CdkDragDrop<Label[]>) {
		if (!this.target) {
			return;
		}

		const phElement = this.placeholder.element.nativeElement;
		const parent = phElement.parentElement;

		phElement.style.display = 'none';

		parent.removeChild(phElement);
		parent.appendChild(phElement);
		parent.insertBefore(this.source.element.nativeElement, parent.children[this.sourceIndex]);

		this.target = null;
		this.source = null;

		if (this.sourceIndex !== this.targetIndex && this.category.Labels) {
			this.cd.detach();
			// moveItemInArray(this.category.Labels, this.sourceIndex, this.targetIndex);
			this.svr.backface
				.setLabelPosition({
					CategoryID: this.category.ID,
					ID: this.category.Labels[this.sourceIndex].ID,
					Position: this.targetIndex
				})
				.subscribe(v => {
					this.category.setLabelsPosition(v.map(vv => vv.ID));
					this.cd.reattach();
				}, this.errProcess());
		}
	}

	dropListEnterPredicate = (drag: CdkDrag, drop: CdkDropList) => {
		if (drop === this.placeholder) {
			return true;
		}
		if (drop !== this.activeContainer) {
			return false;
		}
		const phElement = this.placeholder.element.nativeElement;
		const sourceElement = drag.dropContainer.element.nativeElement;
		const dropElement = drop.element.nativeElement;
		const dragIndex = this.indexOfNum(dropElement.parentElement.children, this.source ? phElement : sourceElement);
		const dropIndex = this.indexOfNum(dropElement.parentElement.children, dropElement);

		if (!this.source) {
			this.sourceIndex = dragIndex;
			this.source = drag.dropContainer;

			phElement.style.width = sourceElement.clientWidth + 'px';
			phElement.style.height = sourceElement.clientHeight + 'px';

			sourceElement.parentElement.removeChild(sourceElement);
		}

		this.targetIndex = dropIndex;
		this.target = drop;

		phElement.style.display = '';
		dropElement.parentElement.insertBefore(
			phElement,
			dropIndex > dragIndex ? dropElement.nextSibling : dropElement
		);

		this.placeholder.enter(drag, drag.element.nativeElement.offsetLeft, drag.element.nativeElement.offsetTop);
		return false;
		// tslint:disable-next-line:semicolon
	};

	getPointerPositionOnPage(event: MouseEvent | TouchEvent) {
		// `touches` will be empty for start/end events so we have to fall back to `changedTouches`.
		const point = __isTouchEvent(event) ? event.touches[0] || event.changedTouches[0] : event;
		const scrollPosition = this.viewportRuler.getViewportScrollPosition();

		return {
			x: point.pageX - scrollPosition.left,
			y: point.pageY - scrollPosition.top
		};
	}
	indexOfNum(collection, node) {
		return Array.prototype.indexOf.call(collection, node);
	}
}
/** Determines whether an event is a touch event. */
function __isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
	return event.type.startsWith('touch');
}

function __isInsideDropListClientRect(dropList: CdkDropList, x: number, y: number) {
	const { top, bottom, left, right } = dropList.element.nativeElement.getBoundingClientRect();
	return y >= top && y <= bottom && x >= left && x <= right;
}
